import { hitEventTms } from "@adeo/tms-lib";
import { storeContextTracking } from "../utils/context-layer-variables";
export function pushLayerDisplayTmsEvent(isContextualized, funnel_name) {
  hitEventTms(window, 'step.display', {
    'feature_name': 'context_layer',
    'step_name': isContextualized ? 'information content' : 'store search',
    'funnel_name': funnel_name || storeContextTracking.funnelName
  });
}
export function sendCdlEventOnStepDisplay(step_name, funnel_name) {
  hitEventTms(window, 'step.display', {
    'feature_name': 'context_layer',
    'step_name': step_name,
    'funnel_name': funnel_name || storeContextTracking.funnelName
  });
}
export function pushStoreCardButtonTracking(buttonName) {
  hitEventTms(window, 'button.click', {
    'feature_name': 'context_layer',
    'step_name': 'information content',
    'funnel_name': storeContextTracking.funnelName,
    'button_name': buttonName
  });
}
export function pushStoreSearchEventsTracking(buttonName, buttonType, buttonLocation) {
  hitEventTms(window, 'button.click', {
    'button_name': buttonName,
    'button_type': buttonType,
    'button_location': buttonLocation
  });
}